<template>
<div class="chapter">
<div class="inner_page">
<p class="C256"><em><a id="page_vii"><strong>Contents</strong></a></em></p><a id="page_vii">
</a><p class="C513"><a id="page_vii"></a><a href="#/xhtml/07_Introduc#page_xiii">Introduction</a></p>
<p class="C258"><a href="#/xhtml/09_One_Amer#page_3"><em>Chapter One</em>. American Policy Toward the Muslim World</a></p>
<p class="C258"><span href="#/xhtml/10_Two_The#page_35" title="Link target outside of Sample"><em>Chapter Two</em>. The United States and the Specter of Islam</span></p>
<p class="C258"><span href="#/xhtml/11_Three_A#page_61" title="Link target outside of Sample"><em>Chapter Three</em>. A Peek Into the Seraglio: Americans, Sex, and the Muslim World</span></p>
<p class="C258"><span href="#/xhtml/12_Four_Ame#page_87" title="Link target outside of Sample"><em>Chapter Four</em>. American Slavery and the Muslim World</span></p>
<p class="C258"><span href="#/xhtml/13_Five_Ame#page_107" title="Link target outside of Sample"><em>Chapter Five</em>. American Captives in the Muslim World</span></p>
<p class="C258"><span href="#/xhtml/15_Six_The#page_127" title="Link target outside of Sample"><em>Chapter Six</em>. The Muslim World and American Benevolence</span></p>
<p class="C258"><span href="#/xhtml/16_Seven_Am#page_153" title="Link target outside of Sample"><em>Chapter Seven</em>. American Consuls in the Muslim World</span></p>
<p class="C258"><span href="#/xhtml/17_Eight_Re#page_187" title="Link target outside of Sample"><em>Chapter Eight</em>. Remembering the Tripolitan War</span></p>
<p class="C513"><span href="#/xhtml/18_Nine_Jam#page_207" title="Link target outside of Sample"><em>Chapter Nine</em>. James Riley, the Return of the Captive</span></p>
<p class="C258"><span href="#/xhtml/19_Notes_#page_227" title="Link target outside of Sample">Notes</span></p>
<p class="C258"><span href="#/xhtml/20_Index_#page_257" title="Link target outside of Sample">Index</span></p>
<p class="C258"><span href="#/xhtml/14_Photo_Se#page_I" title="Link target outside of Sample"><em>illustrations follow Chapter Five</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?152150bc